module.exports = __webpack_public_path__ + "img/community.4a1e9687.png";